import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import CustomDataState from "@NA/Store/Data/CustomApplicationState/CustomDataState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export function getBundledProductsById(state: CustomApplicationState, id: string): ProductModel[] | undefined {
    const bundledProductsById = state.ADIGlobalData.bundledProductsStore.bundledProductsById[id]?.bundledProductByProductId;
    return bundledProductsById;
}
